import ApiService from '../../api/ApiService';
import {DialogCallbacks} from '../../types/common';
import {dispatchAsync} from '../common';
import types from './types';
import api from '../../api';
import {action} from 'redux/helpers';
import {DiplomatObjectTypeUnion} from 'types/DiplomatObjectType';
import {ThunkDispatch} from 'redux-thunk';
import {AnyAction} from 'redux';
import {State} from 'redux/reducer';
import {pageSelectors} from 'features/layout/CommonPage/redux';
import {ITransaction} from 'types/diplomat/transaction/Transaction';
import {FormOnSubmitHelpers} from 'components/hook-form/Formik';

const moveTransaction = (transactionIds: string[], folderId: string, cbs?: DialogCallbacks) =>
   dispatchAsync(api.transactionsMove, types.MOVE_TRANSACTION, {
      ...cbs,
      getMethod: ApiService.postSecureJson,
      data: {
         transactionIds,
         folderId,
      },
   });

const release = (data: any) => action(types.RELEASE_TRANSACTION.SAGA, data);
const suspend = (data: any) => action(types.SUSPEND_TRANSACTION.SAGA, data);

const saveAs = (
   id: string,
   objectType: DiplomatObjectTypeUnion,
   name: string,
   options?: {
      onSuccess?: (data: ITransaction) => void;
      onFailure?: (error: any) => void;
   }
) => async (dispatch: ThunkDispatch<{}, {}, AnyAction>, getState: () => Promise<State>) => {
   const state = await getState();
   const currentObject = pageSelectors.getData(state);
   let transaction = currentObject;
   if (id !== currentObject.id || objectType !== currentObject.objectType) {
      transaction = await dispatch(
         dispatchAsync(`${api.transactions}/${id}`, types.GET_TRANSACTION)
      );
   }

   if (!transaction) {
      console.error('Transaction is null, "Clone" failed', id, objectType, name);
   }

   return dispatch(
      dispatchAsync(api.transactionSaveAs, types.CREATE_TRANSACTION, {
         getMethod: ApiService.postSecureJson,
         data: {
            existingTransaction: transaction,
            newTransactionName: name,
            overwrite: false,
         },
         onSuccess: options?.onSuccess,
         onError: options?.onFailure,
      })
   );
};

const validateTransaction = (data: ITransaction) => action(types.VALIDATE_TRANSACTION.SAGA, {data});
const sendTransaction = (data: ITransaction, helpers?: FormOnSubmitHelpers<any>) =>
   action(types.SEND_TRANSACTION.SAGA, {data, helpers});
const updateTransaction = (data: ITransaction) => action(types.UPDATE_TRANSACTION.SAGA, {data});

export default {
   validateTransaction,
   sendTransaction,
   updateTransaction,
   moveTransaction,
   release,
   suspend,
   saveAs,

   getRefsPgp: (id: string, cbs?: DialogCallbacks) =>
      dispatchAsync(`${api.transactionsRefsPgp}/${id}`, types.GET_REFS_PGP, {
         ...cbs,
      }),
   getRefsSsh: (id: string, cbs?: DialogCallbacks) =>
      dispatchAsync(`${api.transactionsRefsSsh}/${id}`, types.GET_REFS_SSH, {
         ...cbs,
      }),
   getRefsSsl: (id: string, cbs?: DialogCallbacks) =>
      dispatchAsync(`${api.transactionsRefsSsl}/${id}`, types.GET_REFS_SSL, {
         ...cbs,
      }),
   getRefsProxy: (id: string, cbs?: DialogCallbacks) =>
      dispatchAsync(`${api.transactionsRefsProxy}/${id}`, types.GET_REFS_PROXY, {
         ...cbs,
      }),
   getRefsPartner: (id: string, cbs?: DialogCallbacks) =>
      dispatchAsync(`${api.transactionsRefsPartner}/${id}`, types.GET_REFS_PARTNER, {
         ...cbs,
      }),
   getRefsTransaction: (id: string, cbs?: DialogCallbacks) =>
      dispatchAsync(`${api.transactionsRefsTransaction}/${id}`, types.GET_REFS_TRANSACTION, {
         ...cbs,
      }),
};
